<template>
  <div class="place-page container">
    <h1 class="title">Detalhes do Lugar</h1>
    <h2 class="subtitle">{{ Place.name }}</h2>
    <div class="page-content">
      <place-viewer />
      <p class="has-text-centered">
        <router-link :to="`/${$route.params.lang}/places`" class="button is-link">Voltar para listagem de Lugares</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import PlaceViewer from '../PlaceViewer'
import { mapGetters } from 'vuex'
export default {
  name: 'PlacePage',
  components: { PlaceViewer },
  computed: {
    ...mapGetters(['Place'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/PlacePage.vue